/* eslint-disable */
/** Generated by tools/generateTaskTypeCatalog.js. Do not edit by hand. */
export type TaskTypeValidatorCapability = {
  /** A JSON-mode model pass runs on Validate. */
  llm: boolean;
  /** A Pangram AI-authorship pass runs on Validate. */
  aiDetection: boolean;
  /** The detection pass also refuses the first submit attempt. */
  aiDetectionBlocksSubmit: boolean;
};

export type TaskTypeDomainOption = {
  id: string;
  label: string;
};

export type TaskTypeDomainSplit = {
  /** True when a positive target count is refused without a `domainId`. */
  required: boolean;
  /** Ordered — this is the order of the admin dropdown. */
  options: TaskTypeDomainOption[];
};

export type TaskTypeCapability = {
  id: string;
  active: boolean;
  payloadUpload: boolean;
  llmReviewer: boolean;
  llmValidator: boolean;
  /** Null when no validator is registered; see `llmValidator`. */
  validator: TaskTypeValidatorCapability | null;
  approvedSubmission: boolean;
  customExport: boolean;
  widthMode: 'narrow' | 'wide';
  /** Null when this type is not domain-split. */
  domains: TaskTypeDomainSplit | null;
};

export const TASK_TYPE_CAPABILITIES: readonly TaskTypeCapability[] = [
  {
    "id": "arxiv-reasoning",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": true,
    "validator": {
      "llm": true,
      "aiDetection": false,
      "aiDetectionBlocksSubmit": false
    },
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": null
  },
  {
    "id": "browsecomp",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": null
  },
  {
    "id": "bunsen",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": false,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "target-id",
          "label": "Target ID"
        },
        {
          "id": "modality-tpp",
          "label": "Modality & TPP"
        },
        {
          "id": "structure-design",
          "label": "Structure & Design"
        },
        {
          "id": "hit-discovery",
          "label": "Hit Discovery"
        },
        {
          "id": "hit-to-lead",
          "label": "Hit-to-Lead"
        },
        {
          "id": "admet-pkpd",
          "label": "ADMET & PK/PD"
        },
        {
          "id": "translational",
          "label": "Translational"
        },
        {
          "id": "data-ml-infra",
          "label": "Data, ML & Infra"
        },
        {
          "id": "assay-dev",
          "label": "Assay Development"
        }
      ]
    }
  },
  {
    "id": "clinical-rubrics",
    "active": true,
    "payloadUpload": true,
    "llmReviewer": true,
    "llmValidator": true,
    "validator": {
      "llm": true,
      "aiDetection": true,
      "aiDetectionBlocksSubmit": true
    },
    "approvedSubmission": false,
    "customExport": true,
    "widthMode": "narrow",
    "domains": null
  },
  {
    "id": "comp-workflows-drug-discovery",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": true,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "target-id",
          "label": "Target ID"
        },
        {
          "id": "modality-tpp",
          "label": "Modality & TPP"
        },
        {
          "id": "structure-design",
          "label": "Structure & Design"
        },
        {
          "id": "hit-discovery",
          "label": "Hit Discovery"
        },
        {
          "id": "hit-to-lead",
          "label": "Hit-to-Lead"
        },
        {
          "id": "admet-pkpd",
          "label": "ADMET & PK/PD"
        },
        {
          "id": "translational",
          "label": "Translational"
        },
        {
          "id": "data-ml-infra",
          "label": "Data, ML & Infra"
        },
        {
          "id": "assay-dev",
          "label": "Assay Development"
        }
      ]
    }
  },
  {
    "id": "comp-workflows-scientific",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": true,
    "validator": {
      "llm": false,
      "aiDetection": true,
      "aiDetectionBlocksSubmit": false
    },
    "approvedSubmission": true,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "math-applied-mathematics",
          "label": "Math:Applied Mathematics"
        },
        {
          "id": "math-formal-mathematics",
          "label": "Math:Formal Mathematics"
        },
        {
          "id": "math-operations-research",
          "label": "Math:Operations Research"
        },
        {
          "id": "math-statistics",
          "label": "Math:Statistics"
        },
        {
          "id": "physical-sciences-astronomy",
          "label": "Physical Sciences:Astronomy"
        },
        {
          "id": "physical-sciences-chemistry",
          "label": "Physical Sciences:Chemistry"
        },
        {
          "id": "physical-sciences-materials-science",
          "label": "Physical Sciences:Materials Science"
        },
        {
          "id": "physical-sciences-physics",
          "label": "Physical Sciences:Physics"
        },
        {
          "id": "engineering-chemical-engineering",
          "label": "Engineering:Chemical Engineering"
        },
        {
          "id": "engineering-civil-engineering",
          "label": "Engineering:Civil Engineering"
        },
        {
          "id": "engineering-electrical-engineering",
          "label": "Engineering:Electrical Engineering"
        },
        {
          "id": "engineering-mechanical-engineering",
          "label": "Engineering:Mechanical Engineering"
        },
        {
          "id": "earth-science-atmospheric-sciences",
          "label": "Earth Science:Atmospheric Sciences"
        },
        {
          "id": "earth-science-environmental-sciences",
          "label": "Earth Science:Environmental Sciences"
        },
        {
          "id": "earth-science-geosciences",
          "label": "Earth Science:Geosciences"
        },
        {
          "id": "earth-science-ocean-sciences",
          "label": "Earth Science:Ocean Sciences"
        },
        {
          "id": "biology-bioinformatics",
          "label": "Biology:Bioinformatics"
        },
        {
          "id": "biology-genetics",
          "label": "Biology:Genetics"
        }
      ]
    }
  },
  {
    "id": "computational-workflow",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "narrow",
    "domains": null
  },
  {
    "id": "computational-workflow-docker",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": true,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "math",
          "label": "Math"
        },
        {
          "id": "physics",
          "label": "Physics"
        },
        {
          "id": "materials",
          "label": "Materials"
        },
        {
          "id": "bio",
          "label": "Bio"
        },
        {
          "id": "chemistry",
          "label": "Chemistry"
        },
        {
          "id": "economics",
          "label": "Economics"
        }
      ]
    }
  },
  {
    "id": "feedback-form",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "narrow",
    "domains": null
  },
  {
    "id": "finance-rubrics",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": true,
    "validator": {
      "llm": false,
      "aiDetection": true,
      "aiDetectionBlocksSubmit": true
    },
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "private-equity",
          "label": "Private Equity"
        },
        {
          "id": "fpa",
          "label": "FP&A"
        },
        {
          "id": "investment-banking",
          "label": "Investment Banking"
        },
        {
          "id": "audit-accounting",
          "label": "Audit & Accounting"
        }
      ]
    }
  },
  {
    "id": "finance-agent-conversations",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": false,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": null
  },
  {
    "id": "finance-build-rubrics",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": true,
    "validator": {
      "llm": false,
      "aiDetection": true,
      "aiDetectionBlocksSubmit": true
    },
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "investment-banking",
          "label": "Investment Banking (M&A)"
        },
        {
          "id": "private-equity",
          "label": "Private Equity"
        },
        {
          "id": "venture-capital",
          "label": "Venture Capital"
        },
        {
          "id": "corporate-development",
          "label": "Corporate Development"
        },
        {
          "id": "fpa",
          "label": "Financial Planning & Analysis (FP&A)"
        },
        {
          "id": "treasury",
          "label": "Treasury"
        },
        {
          "id": "hedge-funds",
          "label": "Hedge Funds"
        },
        {
          "id": "asset-management",
          "label": "Asset Management"
        },
        {
          "id": "sales-trading",
          "label": "Sales & Trading"
        },
        {
          "id": "equity-research",
          "label": "Equity Research"
        },
        {
          "id": "quantitative-finance",
          "label": "Quantitative Finance"
        },
        {
          "id": "private-credit",
          "label": "Private Credit / Direct Lending"
        },
        {
          "id": "commercial-banking",
          "label": "Commercial Banking"
        },
        {
          "id": "structured-finance",
          "label": "Structured Finance"
        },
        {
          "id": "real-estate-private-equity",
          "label": "Real Estate Private Equity"
        },
        {
          "id": "infrastructure-energy",
          "label": "Infrastructure & Energy"
        }
      ]
    }
  },
  {
    "id": "environment-builder",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": false,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": true,
    "widthMode": "wide",
    "domains": null
  },
  {
    "id": "gdm-rubrics",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": true,
    "validator": {
      "llm": true,
      "aiDetection": false,
      "aiDetectionBlocksSubmit": false
    },
    "approvedSubmission": false,
    "customExport": true,
    "widthMode": "narrow",
    "domains": {
      "required": false,
      "options": [
        {
          "id": "math",
          "label": "Math"
        },
        {
          "id": "math-ac",
          "label": "Commutative Algebra"
        },
        {
          "id": "math-ag",
          "label": "Algebraic Geometry"
        },
        {
          "id": "math-ap",
          "label": "Analysis of PDEs (Partial Differential Equations)"
        },
        {
          "id": "math-at",
          "label": "Algebraic Topology"
        },
        {
          "id": "math-ca",
          "label": "Classical Analysis and ODEs (Ordinary Differential Equations)"
        },
        {
          "id": "math-co",
          "label": "Combinatorics"
        },
        {
          "id": "math-ct",
          "label": "Category Theory"
        },
        {
          "id": "math-cv",
          "label": "Complex Variables"
        },
        {
          "id": "math-dg",
          "label": "Differential Geometry"
        },
        {
          "id": "math-ds",
          "label": "Dynamical Systems"
        },
        {
          "id": "math-fa",
          "label": "Functional Analysis"
        },
        {
          "id": "math-gn",
          "label": "General Topology"
        },
        {
          "id": "math-gr",
          "label": "Group Theory"
        },
        {
          "id": "math-gt",
          "label": "Geometric Topology"
        },
        {
          "id": "math-kt",
          "label": "K-Theory and Homology"
        },
        {
          "id": "math-lo",
          "label": "Logic"
        },
        {
          "id": "math-mp",
          "label": "Mathematical Physics"
        },
        {
          "id": "math-na",
          "label": "Numerical Analysis"
        },
        {
          "id": "math-nt",
          "label": "Number Theory"
        },
        {
          "id": "math-oa",
          "label": "Operator Algebras"
        },
        {
          "id": "math-oc",
          "label": "Optimization and Control"
        },
        {
          "id": "math-pr",
          "label": "Probability"
        },
        {
          "id": "math-qa",
          "label": "Quantum Algebra"
        },
        {
          "id": "math-ra",
          "label": "Rings and Algebras"
        },
        {
          "id": "math-rt",
          "label": "Representation Theory"
        },
        {
          "id": "math-sg",
          "label": "Symplectic Geometry"
        },
        {
          "id": "math-sp",
          "label": "Spectral Theory"
        },
        {
          "id": "physics",
          "label": "Physics"
        },
        {
          "id": "bio",
          "label": "Biology"
        },
        {
          "id": "chemistry",
          "label": "Chemistry"
        },
        {
          "id": "materials",
          "label": "Materials"
        },
        {
          "id": "economics",
          "label": "Economics"
        }
      ]
    }
  },
  {
    "id": "drug-discovery-rubrics",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": true,
    "validator": {
      "llm": true,
      "aiDetection": true,
      "aiDetectionBlocksSubmit": true
    },
    "approvedSubmission": false,
    "customExport": true,
    "widthMode": "narrow",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "target-id",
          "label": "Target ID"
        },
        {
          "id": "modality-tpp",
          "label": "Modality & TPP"
        },
        {
          "id": "structure-design",
          "label": "Structure & Design"
        },
        {
          "id": "hit-discovery",
          "label": "Hit Discovery"
        },
        {
          "id": "hit-to-lead",
          "label": "Hit-to-Lead"
        },
        {
          "id": "admet-pkpd",
          "label": "ADMET & PK/PD"
        },
        {
          "id": "translational",
          "label": "Translational"
        },
        {
          "id": "data-ml-infra",
          "label": "Data, ML & Infra"
        },
        {
          "id": "assay-dev",
          "label": "Assay Development"
        }
      ]
    }
  },
  {
    "id": "document-rewrites",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": false,
    "llmValidator": true,
    "validator": {
      "llm": false,
      "aiDetection": true,
      "aiDetectionBlocksSubmit": true
    },
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": true,
      "options": [
        {
          "id": "legal",
          "label": "Legal"
        },
        {
          "id": "finance",
          "label": "Finance"
        },
        {
          "id": "medical-research",
          "label": "Medical Research"
        }
      ]
    }
  },
  {
    "id": "open-problems-hitl-auto",
    "active": true,
    "payloadUpload": true,
    "llmReviewer": false,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "narrow",
    "domains": null
  },
  {
    "id": "open-problems-hitl-math",
    "active": true,
    "payloadUpload": true,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "narrow",
    "domains": null
  },
  {
    "id": "open-problems-hitl-physics",
    "active": true,
    "payloadUpload": true,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "narrow",
    "domains": null
  },
  {
    "id": "slop-rewrite",
    "active": true,
    "payloadUpload": true,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": null
  },
  {
    "id": "synthetic-rl-env",
    "active": true,
    "payloadUpload": true,
    "llmReviewer": false,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "wide",
    "domains": {
      "required": false,
      "options": [
        {
          "id": "math-applied-mathematics",
          "label": "Math:Applied Mathematics"
        },
        {
          "id": "math-formal-mathematics",
          "label": "Math:Formal Mathematics"
        },
        {
          "id": "math-operations-research",
          "label": "Math:Operations Research"
        },
        {
          "id": "math-statistics",
          "label": "Math:Statistics"
        },
        {
          "id": "physical-sciences-astronomy",
          "label": "Physical Sciences:Astronomy"
        },
        {
          "id": "physical-sciences-chemistry",
          "label": "Physical Sciences:Chemistry"
        },
        {
          "id": "physical-sciences-materials-science",
          "label": "Physical Sciences:Materials Science"
        },
        {
          "id": "physical-sciences-physics",
          "label": "Physical Sciences:Physics"
        },
        {
          "id": "engineering-chemical-engineering",
          "label": "Engineering:Chemical Engineering"
        },
        {
          "id": "engineering-civil-engineering",
          "label": "Engineering:Civil Engineering"
        },
        {
          "id": "engineering-electrical-engineering",
          "label": "Engineering:Electrical Engineering"
        },
        {
          "id": "engineering-mechanical-engineering",
          "label": "Engineering:Mechanical Engineering"
        },
        {
          "id": "earth-science-atmospheric-sciences",
          "label": "Earth Science:Atmospheric Sciences"
        },
        {
          "id": "earth-science-environmental-sciences",
          "label": "Earth Science:Environmental Sciences"
        },
        {
          "id": "earth-science-geosciences",
          "label": "Earth Science:Geosciences"
        },
        {
          "id": "earth-science-ocean-sciences",
          "label": "Earth Science:Ocean Sciences"
        },
        {
          "id": "biology-bioinformatics",
          "label": "Biology:Bioinformatics"
        },
        {
          "id": "biology-genetics",
          "label": "Biology:Genetics"
        },
        {
          "id": "drug-discovery",
          "label": "Drug Discovery"
        }
      ]
    }
  },
  {
    "id": "workflow-map",
    "active": true,
    "payloadUpload": false,
    "llmReviewer": true,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "narrow",
    "domains": null
  },
  {
    "id": "legacy",
    "active": false,
    "payloadUpload": false,
    "llmReviewer": false,
    "llmValidator": false,
    "validator": null,
    "approvedSubmission": false,
    "customExport": false,
    "widthMode": "narrow",
    "domains": null
  }
];

const BY_ID = new Map(TASK_TYPE_CAPABILITIES.map((entry) => [entry.id, entry]));

export function listTaskTypeCapabilities(): readonly TaskTypeCapability[] {
  return TASK_TYPE_CAPABILITIES;
}

export function getTaskTypeCapabilities(id: string | null | undefined): TaskTypeCapability | null {
  if (!id) return null;
  return BY_ID.get(id) ?? null;
}
